import CollectionsIcon from '@mui/icons-material/Collections'
import { Badge, Button, ButtonProps, IconButton, Tooltip } from '@mui/material'
import { FC, useMemo, useState } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useGetRepairOrderMediaEntriesQuery } from '../../../redux/api'
import RepairOrderMediaDialog from './RepairOrderMediaDialog'

interface Props extends ButtonProps {
  repairOrderId: string
  iconOnly?: boolean
}

const RepairOrderMediaButton: FC<Props> = ({
  repairOrderId,
  iconOnly,
  ...props
}) => {
  const { accessToken } = useAccessTokenAndShopId()

  const [dialogOpen, setDialogOpen] = useState<boolean>(false)
  const handleClose = () => setDialogOpen(false)

  const { data: media, isLoading: isLoadingMedia } =
    useGetRepairOrderMediaEntriesQuery({
      authorization: accessToken,
      repairOrder: repairOrderId
    })

  const filteredMedia = useMemo(() => {
    return media?.filter((m) => {
      return !m.info?.archived
    })
  }, [media])
  const icon = useMemo(
    () =>
      !isLoadingMedia && filteredMedia ? (
        <Badge badgeContent={filteredMedia.length} color="primary">
          <CollectionsIcon color="primary" />
        </Badge>
      ) : (
        <CollectionsIcon color="primary" />
      ),
    [isLoadingMedia, filteredMedia]
  )
  const disabled = useMemo(
    () => isLoadingMedia || filteredMedia === undefined,
    [isLoadingMedia, filteredMedia]
  )

  return (
    <>
      {!isLoadingMedia && filteredMedia && (
        <RepairOrderMediaDialog
          open={dialogOpen}
          handleClose={handleClose}
          media={filteredMedia}
          repairOrderId={repairOrderId}
        />
      )}

      <Tooltip
        title={
          isLoadingMedia ? 'Loading...' : 'View media gallery for repair order'
        }>
        {iconOnly ? (
          <IconButton onClick={() => setDialogOpen(true)} disabled={disabled}>
            {icon}
          </IconButton>
        ) : (
          <span
            style={{
              display: 'flex'
            }}>
            <Button
              variant="text"
              color="primary"
              onClick={() => setDialogOpen(true)}
              disabled={disabled}
              startIcon={icon}
              {...props}>
              Gallery
            </Button>
          </span>
        )}
      </Tooltip>
    </>
  )
}

export default RepairOrderMediaButton
